import type { ThemeOptions } from '@mui/material'

export const themeOptions = {
  components: {
    MuiAvatar: {
      styleOverrides: {
        root: {
          // Remove default grey background from SummaryItem thumbnails
          backgroundColor: 'transparent',
        },
      },
    },

    PhxSceneFab: {
      styleOverrides: {
        fab: {
          textTransform: 'none',
        },
      },
    },
  },
} satisfies ThemeOptions
